import { InternetSpeed } from '../model/enumerations/internet-speed.model';
import { ISelect } from '../model/iSelect';

export const internetSpeedEnum = (): Array<ISelect> => {
  const internetSpeed: Array<ISelect> = [
    {
      label: "Ninguna",
      value: InternetSpeed.NONE,
    },
    {
      label: "Menor a 15",
      value: InternetSpeed.LESS_THAN_15,
    },
    {
      label: "Entre 15 y 30",
      value: InternetSpeed.BETWEEN_15_30,
    },
    {
      label: "Mayor a 30",
      value: InternetSpeed.MORE_THAN_30,
    },
  ];
  return internetSpeed;
};
